import { Select as HeadlessSelect, SelectProps } from "@headlessui/react";

export default function Select({
    children,
    className,
    ...rest
}: SelectProps & { id?: never }) {
    return (
        <HeadlessSelect
            className={`rounded-md shadow-sm border-gray-300 focus:border-gray-300 focus:ring-3 focus:ring-gray-200/50 ${
                className ?? ""
            }`}
            {...rest}
        >
            {children}
        </HeadlessSelect>
    );
}
